 
function strToLowercase(str) {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
}

function formatCategory(category) {
  var splitted = category.split('_');

  var formatted = [];

  for (var i = 0; i < splitted.length; i += 1) {
      var str = splitted[i];
      formatted.push(strToLowercase(str).replace('-', '/'));
  }

  return formatted.join(' ');
}

function getCategoriesFromUrlPath(url) {
  var categories = [];
  var handles = [];

  if (!url) {
      return { categories: categories, handles: handles };
  }

  var splitted = url.split('__');

  for (var i = 0; i < splitted.length; i += 1) {
      categories.push(formatCategory(splitted[i]));
      if (i === 0) {
          handles.push(splitted[i]);
      } else {
          handles.push(splitted[i - 1] + '__' + splitted[i]);
      }
  }

  return { categories, handles };
}

function parseCollectionPath(colPath) {
  var splittedPath = colPath.split('/');
  var colSlot = [splittedPath[0], splittedPath[1]].join('/');
  return Object.assign({ slot: colSlot }, getCategoriesFromUrlPath(splittedPath[2]));
}

function getRulesWithoutCategories(rules) {
  var result = [];

  for (var i = 0; i < rules.length; i += 1) {
      var rule = rules[i];
      var type = rule.get ? rule.get('type') : rule.type
      if (type !== 'category') {
          result.push(rule);
      }
  }

  return result;
}

function eliminateDuplicates(arr) {
  
  var uniqueWords = new Set();

  return arr.filter((word) => {
      var lowercaseWord = word.toLowerCase();
      var singularWord = lowercaseWord.replace(/s$/, ''); // Remove trailing 's' to convert to singular form

      if (!uniqueWords.has(singularWord)) {
          uniqueWords.add(singularWord);
          return true;
      }
      return false;
  });
}

function cleanSlug(slug){
  var clean_slug = slug;
  if (slug.endsWith('/')) { // Have to clean slug, once sidebar is used, the new slug has / at the end
      var clean_slug = slug.slice(0, -1);
  }
  return clean_slug;
}

function normalizePath(path) {
  return path.replace(/\/+$/, '');
}

function getSEOData(currentSlug, seoSettings) {
  const normalizedCurrent = normalizePath(currentSlug);

  for (const target of seoSettings) {
    const targetPath = normalizePath(`/collections/${target.target_slug}`);

    if (normalizedCurrent === targetPath) {
      return {
        isSeoData: true,
        metaTitle: target.meta_title,
        metaDesc: target.meta_description,
        seoH1: target.seo_h1,
        seoPageTop: target.top_content,
        seoPageBottom: target.bottom_content,
        seoCanonical: target.canonical,
        seoNoIndex: target.no_index,
      };
    }
  }

  return null;
}


function setDefaultTitle(x, SEO_MODEL) {
  
  var updatedTitle = x.replace(/\bBrakes\b/g, "Brake");
  //console.log("++ updatedTitle: ", updatedTitle);

  if (updatedTitle.includes("Brake Big")) {
      updatedTitle = updatedTitle.replace("Brake Big", "Big Brakes");
    //console.log('hit a');
  } else if (updatedTitle === `${SEO_MODEL} Engine Intake Manifold`) {
      updatedTitle = updatedTitle.replace("Engine Intake", "Intake");
    //console.log('hit b');
  } else if (updatedTitle === `${SEO_MODEL} Engine Intake Chargepipes/inlets`) {
      updatedTitle = updatedTitle.replace("Engine Intake Chargepipes/inlets", "Chargepipes & Inlet Pipes");
    //console.log('hit c');
  } else if (updatedTitle === `${SEO_MODEL} Suspension Install Kit`) {
      updatedTitle = updatedTitle;  
    //console.log('hit d');
  } else if (updatedTitle.includes("Brake Parking")) {
      updatedTitle = updatedTitle.replace("Brake Parking", "Parking Brake");
    //console.log('hit e');
  } else if (updatedTitle === `${SEO_MODEL} Drivetrain`) {
      updatedTitle = updatedTitle.replace("Drivetrain", "Drivetrain Parts");
    //console.log('hit f');
  } else if (updatedTitle === `${SEO_MODEL} Interior`) {
      updatedTitle = updatedTitle.replace("Interior", "Interior Parts"); 
    //console.log('hit g');
  } else if (updatedTitle.includes("Drivetrain")) {
      updatedTitle = updatedTitle.replace("Drivetrain", "");    
    console.log('hit h');
  } else if (updatedTitle === `${SEO_MODEL} Suspension Bushings & Components`) {
      updatedTitle = updatedTitle; 
    //console.log('hit i');
  } else if (updatedTitle.includes("Suspension Bushings & Components")) {
      updatedTitle = updatedTitle.replace("Suspension Bushings & Components", "");
    //console.log('hit j');
  } else if (updatedTitle === `${SEO_MODEL} Engine`) {
      updatedTitle = updatedTitle.replace("Engine", "Engine Parts");  
    //console.log('hit k');
  } else if (updatedTitle === `${SEO_MODEL} Brake`) {
      updatedTitle = updatedTitle.replace("Brake", "Brakes");  
    //console.log('hit m');
  } else if (updatedTitle.includes("Suspension Bushings & Components")) {
      updatedTitle = updatedTitle;  
    //console.log('hit n');
  } else if (updatedTitle.includes(`${SEO_MODEL} Suspension `)) {
      updatedTitle = updatedTitle.replace("Suspension ", "");  
    //console.log('hit o');
  } else if (updatedTitle === `${SEO_MODEL} Climate Control`) {
      updatedTitle = updatedTitle.replace("Climate Control", "AC and Climate Control Parts");  
    //console.log('hit p');
  } else if (updatedTitle === `${SEO_MODEL} All Urotuning Kits`) {
      updatedTitle = updatedTitle.replace(`${SEO_MODEL} All Urotuning Kits`, `Must Have Kits for ${SEO_MODEL}`);  
    //console.log('hit q');
  } else if (updatedTitle === `${SEO_MODEL} Steering`) {
      updatedTitle = updatedTitle.replace(`${SEO_MODEL} Steering`, `${SEO_MODEL} Steering Parts`); 
    //console.log('hit r');
  } else if (updatedTitle === `${SEO_MODEL} Engine Intake Air`) {
      updatedTitle = updatedTitle.replace("Engine Intake Air", "Air Intake"); 
    //console.log('hit s');
  } else if (updatedTitle === `${SEO_MODEL} Engine Intake`) {
      updatedTitle = updatedTitle.replace("Engine Intake", "Engine Intake Parts");  
    //console.log('hit t');
  } else if (updatedTitle.includes(`${SEO_MODEL} Engine Intake`)) {
      updatedTitle = updatedTitle.replace("Engine Intake", "");
    //console.log('hit u');
  } else if (updatedTitle.includes(`${SEO_MODEL} Engine Turbocharger Turbocharger`)) {
      updatedTitle = updatedTitle.replace("Engine Turbocharger Turbocharger", "Turbos");
    //console.log('hit v');
  } else if (updatedTitle === `${SEO_MODEL} Engine Turbocharger`) {
      updatedTitle = updatedTitle.replace("Engine Turbocharger", "Turbo Parts");
    //console.log('hit w');
  } else if (updatedTitle.includes(`${SEO_MODEL} Engine Turbocharger`)) {
      updatedTitle = updatedTitle.replace("Engine Turbocharger", "Turbo");
    //console.log('hit x');
  } else if (updatedTitle.includes(`${SEO_MODEL} Engine Software`)) {
      updatedTitle = updatedTitle.replace("Engine Software", "Engine Tunes");
    //console.log('hit y');
  }

  if (updatedTitle.includes("Active")) {
      updatedTitle = updatedTitle.replace("Active", "Active Suspension Parts");
    //console.log('hit z');
  } else if (updatedTitle.includes(`${SEO_MODEL} Camber`)) {
      updatedTitle = updatedTitle.replace("Camber", "Camber Parts");
    //console.log('hit !');
  } else if (updatedTitle.includes("Install / Refresh")) {
      updatedTitle = updatedTitle.replace("Install", "Suspension Install");
    //console.log('hit ?');
  }
  
  //console.log("++ updatedTitle returned: ", updatedTitle);
  return updatedTitle;
  
}

function setDefaultDesc(updatedTitle, SEO_MODEL) {
//console.log("++ updatedtitle passed to desc: ", updatedTitle);
    var descText = "";

    if (updatedTitle === " ") { 
      updatedTitle = SEO_MODEL;  
    } else if (updatedTitle.includes("Brake Pads")) {
        descText = `We have the best Performance Brake Pads for your ${SEO_MODEL}. We offer performance brake pads from brands like EBC and Hawk Performance. Whether you want to enhance your stopping power or improve your daily driving experience, our selection of OEM and Performance brake pads has your ${SEO_MODEL} covered.`;
    } else if (updatedTitle.includes("Brake Rotors")) {
        descText = `We have the best Performance Brake Rotors for your ${SEO_MODEL}. We offer performance brake rotors from brands like EBC, Stoptech and many more. Whether you want to enhance your stopping power or improve your daily driving experience, our selection of OEM and Performance brake rotors has your ${SEO_MODEL} covered.`;
    } else if (updatedTitle === `${SEO_MODEL} Brakes`) {
        descText = `Pump up your ${SEO_MODEL} performance by upgrading with performance brake pads, rotors or a big brake kit. UroTuning is your one stop shop for all brake parts you need for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("Big Brakes")) {
      console.log("++ desc: updatedtitle includes big brakes: ", updatedTitle);
        descText = `We have the best Big Brake Kits for your ${SEO_MODEL}. We offer Big Brake Kits from brands like EBC, Brembo, Stoptech and many more. Whether you want to enhance your stopping power or improve your daily driving experience, our selection of BBK's has your ${SEO_MODEL} covered.`;
    } else if (updatedTitle.includes("Brake Lines")) {
        descText = `Enhance your ${SEO_MODEL}'s braking system with high-performance stainless steel brake lines. Often overlooked but crucial, braided lines offer improved performance, durability, and brake pedal feel. Don't compromise on safety – upgrade your ${SEO_MODEL} brake lines today!`;         
    } else if (updatedTitle.includes("Brake Parts")) {
        descText = `Upgrade your ${SEO_MODEL}'s braking performance with our wide selection of quality brake parts. Explore our range of high-quality brake components for optimal safety and driving experience. Find the perfect fit for your ${SEO_MODEL} model today!`;
    } else if (updatedTitle.includes("Brake Caliper")) {
        descText = `Ensure peak braking performance with brake caliper rebuild kits and freshly rebuilt calipers for your ${SEO_MODEL}. Prevent issues like seized pistons, brake dragging, and vibrations caused by rust. Rebuilt calipers are cleaned, sand-blasted, and equipped with new seals for a hassle-free replacement. No mess, no fuss – just a direct fit for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("Brake Master Cylinder")) {
        descText = `The brake master cylinder distributes fluid to the front and rear brakes on your ${SEO_MODEL}. The reservoir sits atop it, connected to hard metal brake lines. Leaks in the master cylinder or o-rings within can lead to a spongy brake pedal. External metal lines may also develop o-ring issues, causing fluid seepage or air/moisture intake. Shop top quality brake master cylinders for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("Brake Oem Kits")) {
        descText = `Upgrade your ${SEO_MODEL} braking performance with our wide selection of quality OEM Brake Kits. Carefully curated, each kit includes high-quality brake pads and rotors designed to meet ${SEO_MODEL}'s standards for precision and reliability. Elevate your driving experience with superior stopping power and optimal braking efficiency. Trust in the excellence of ${SEO_MODEL} OEM Brake Kits for a smooth and safe ride.`;
    } else if (updatedTitle.includes("Brake Sport Kits")) {
        descText = `Upgrade your ${SEO_MODEL} braking performance with our Sport Brake Kits. Carefully curated, each kit includes performance brake pads and rotors designed to exceed ${SEO_MODEL}'s standards for precision stopping. Elevate your driving experience with superior stopping power and optimal braking efficiency. Trust in the excellence of ${SEO_MODEL} Performance Brake Kits for a smooth and safe ride.`;
    } else if (updatedTitle.includes("Car Care")) {
        descText = `We want the very best for cars and the people who love them. For dedicated car lovers like ourselves, indulging in car care is a delightful experience. We eagerly anticipate weekends spent in the garage. At UroTuning, we go all out to present an exceptional selection of car care products for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("AC and Climate Control Parts")) {
        descText = `Whether your ${SEO_MODEL}'s air conditioning is not working properly or you require additional warmth in the winter, we have the solutions you need. We stock many parts for your ${SEO_MODEL} including heater cores, AC parts, blower motors, and more. Here's a helpful tip: If your air conditioning or heater is not functioning at all or displaying inconsistent behavior with a single speed, the probable cause might be the resistor.`;
    } else if (updatedTitle.includes("Drivetrain Parts")) {
        descText = `Perfecting your ${SEO_MODEL} goes beyond adding horsepower and a stiff suspension. Optimize power delivery by focusing on the drivetrain. Many ${SEO_MODEL}s prioritize comfort, leading to potential power loss. Explore our selection for custom Limited Slip Differentials, Short Shift Conversions, Performance Clutch Discs, Lightweight Flywheels, and more to elevate your driving experience.`;
    } else if (updatedTitle === `${SEO_MODEL} Suspension`) {
        descText = `Shop for premium ${SEO_MODEL} suspension parts, engineered for optimal performance and durability. Enhance your driving experience with our wide selection of shocks, springs, bushings and more fit for all ${SEO_MODEL} models. Experience superior handling and comfort. Shop now for quality ${SEO_MODEL} suspension upgrades.`;
    } else if (updatedTitle === `Must Have Kits for ${SEO_MODEL}`) {
        descText = `Discover a curated selection of must-have kits meticulously crafted for your ${SEO_MODEL}. UroTuning simplifies your search by offering top-quality, expertly assembled kits, ensuring you get the right ${SEO_MODEL} parts. Shop now for quality UroTuning assembled kits for your ${SEO_MODEL}.`;
    } else if (updatedTitle === `${SEO_MODEL} Engine Parts`) {
        descText = `When it comes to boosting your ${SEO_MODEL}'s performance, don't compromise on quality. UroTuning is your one-stop destination for the finest selection of ${SEO_MODEL} Performance and OEM engine parts. Our extensive inventory boasts a vast range of high-quality brands, all at competitive prices. Elevate your ${SEO_MODEL}'s power and performance with our premium ${SEO_MODEL} engine parts today!`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Exterior`)) {
        descText = `Elevate the appearance of your ${SEO_MODEL} to new heights with our carefully curated selection of top-quality exterior parts. From sleek body kits to eye-catching accessories and basic replacement parts, we offer a range of options to help you personalize and upgrade your ${SEO_MODEL}'s aesthetics. Explore our collection now to transform your ${SEO_MODEL}'s exterior into a true reflection of your style and sophistication.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Interior`)) {
        descText = `Elevate the interior of your ${SEO_MODEL} with our handpicked selection of high-quality interior parts. From custom shift knobs and upgraded trim to advanced tech accessories, we offer a range of options to enhance the comfort and style of your ${SEO_MODEL}. Explore our collection now to transform your ${SEO_MODEL}'s interior into a haven of sophistication and convenience.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Lighting`)) {
        descText = `Brighten up your driving experience with UroTuning's exceptional selection of top-quality lighting parts designed specifically for ${SEO_MODEL}. From dazzling headlights to dynamic LED enhancements, we offer a variety of lighting options to enhance both style and performance. Explore our collection now to light up the road ahead and give your ${SEO_MODEL} a distinctive and eye-catching appearance.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Race Dept`)) {
        descText = `Unleash the full potential of your ${SEO_MODEL} with our wide selection of racing parts. From high-performance engine components to precision-tuned suspension systems, we offer a wide range of racing parts designed to elevate your driving experience. Explore our collection now to optimize your ${SEO_MODEL} for the track and take your driving passion to the next level.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Steering`)) {
        descText = `Take control of your driving experience with UroTuning's selection of high-quality steering parts designed to enhance your ${SEO_MODEL}. From steering wheels, racks, pumps and more we offer a comprehensive range of steering parts. Explore our collection now to ensure your ${SEO_MODEL} handles with confidence and precision, providing you with a safer and more enjoyable ride.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Suspension Bushings & Components`)) {
        descText = `Elevate your ${SEO_MODEL}'s suspension system with our top-quality bushings and components. From control arms, ball joints, strut mounts and bushings we offer a comprehensive selection of suspension parts designed to enhance and refresh your vehicle's ride quality and handling. Explore our collection now to ensure that your ${SEO_MODEL} glides smoothly and handles like a dream, providing you with a superior driving experience.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Air Ride`)) {
        descText = `Experience a new level of function and performance with our premium air ride suspension systems for your ${SEO_MODEL}. From air bags and struts to advanced management kits, we offer a comprehensive range of air ride components to get your ${SEO_MODEL} aired out! Shop top brands like <b>Air Lift & AccuAir</b>. Need help? Our amazing staff is just a <u><a href=https://www.urotuning.com/pages/contact-us>click or call</a></u> away to help make your dreams of being on air come true.`;
    } else if (updatedTitle.includes("Ball Joint")) {
        descText = `Ensure a smoother and safer ride for your ${SEO_MODEL} with our high-quality ball joints. These critical components play a vital role in your vehicle's suspension system, providing stability and control. Our selection includes precision-engineered ball joints designed to meet the demands of your ${SEO_MODEL}. Explore our collection now to enhance your ${SEO_MODEL}'s handling and enjoy a more comfortable and controlled driving experience.`;
    } else if (updatedTitle.includes("Bump Stop")) {
        descText = `Improve your ${SEO_MODEL}'s suspension and ride comfort with our high-quality bump stops. Bump stops are crucial components that help control your vehicle's suspension travel, ensuring a smoother and more controlled ride. Our selection includes precision-engineered bump stops designed to meet the specific needs of your ${SEO_MODEL}. Explore our collection now to optimize your ${SEO_MODEL}'s suspension and enjoy a more comfortable and responsive driving experience.`;
    } else if (updatedTitle.includes("Control Arms")) {
        descText = `Take command of your ${SEO_MODEL}'s handling and performance with our wide selection of quality control arms. These vital components are the center of your vehicle's suspension system, ensuring stability and control on the road. UroTuning's selection features precision-engineered control arms designed to meet or exceed the needs of your ${SEO_MODEL}. Shop our selection now to optimize your ${SEO_MODEL}'s suspension and experience a more precise, comfortable, and enjoyable ride.`;
    } else if (updatedTitle.includes("Install / Refresh Kits")) {
        descText = `Breathe new life into your ${SEO_MODEL}'s suspension system with our comprehensive suspension refresh kits. These all-in-one kits are designed to restore and enhance your vehicle's ride quality, handling, and performance. UroTuning has carefully curated these kits to ensure that your ${SEO_MODEL} feels like new again. Shop our suspension kits now to give your ${SEO_MODEL} the suspension makeover it deserves, and enjoy a smoother, more responsive driving experience.`;
    } else if (updatedTitle.includes("Strut Mount")) {
        descText = `Experience a smoother and more controlled ride with our high-quality strut mounts designed specifically for your ${SEO_MODEL}. Strut mounts play a crucial role in your vehicle's suspension system, providing stability and comfort. Our selection includes precision-engineered strut mounts that are tailor-made for your ${SEO_MODEL}, ensuring optimal fit and performance. Explore our collection now to enhance your ${SEO_MODEL}'s handling and enjoy a refreshed driving experience.`;
    } else if (updatedTitle.includes("Tie Rods")) {
        descText = `Enhance your ${SEO_MODEL}'s steering precision and control with our premium tie rods. These critical components are essential for maintaining proper alignment and ensuring responsive handling. Our selection features precision-engineered tie rods designed to meet the exacting standards of your ${SEO_MODEL}. Explore our collection now to optimize your ${SEO_MODEL}'s steering performance, providing you with a safer and more enjoyable driving experience.`;
    } else if (updatedTitle.includes("Camber Parts")) {
        descText = `Achieve the perfect alignment and improve your ${SEO_MODEL}'s handling with our wide selection of quality camber parts. Our selection includes precision-engineered components designed to fine-tune your vehicle's camber angle, ensuring optimal tire contact with the road. Explore our collection now to enhance your ${SEO_MODEL}'s performance, cornering ability, and overall driving experience. Trust in our high-quality camber parts to take your ${SEO_MODEL} to the next level of precision and control.`;
    } else if (updatedTitle.includes("Chassis")) {
        descText = `Enhance your ${SEO_MODEL}'s structural integrity and performance with our high-quality chassis bracing components. These precision-engineered parts are designed to reinforce and stiffen your vehicle's chassis, providing improved handling and responsiveness. Explore our collection now to optimize your ${SEO_MODEL}'s chassis, ensuring a more stable and agile driving experience. Trust in our chassis bracing components to take your ${SEO_MODEL} to the next level of control and confidence on the road.`;
    } else if (updatedTitle.includes("Coilovers")) {
        descText = `For the ultimate suspension setup for your ${SEO_MODEL}, look no further than a set of coilovers. Dial in the perfect stance for your ${SEO_MODEL} with fully adjustable coilovers. UroTuning offers many options for every budget when it comes to shopping for ${SEO_MODEL} coilovers. Shop top brands like KW, ST, H&R, BC Racing, Bilstein, Solo-Werks, Vogtland, and much more!`;
    } else if (updatedTitle.includes("Cup Kit")) {
        descText = `Discover the Ultimate Suspension Upgrade for your ${SEO_MODEL} with a Suspension Cup Kit. Composed of precision-engineered shocks matched with lowering springs, suspension cup kits are designed to provide enhanced handling, improved stability, and a lower stance. Shop our range of suspension cup kits today and take your ${SEO_MODEL}'s suspension to the next level.`;
    } else if (updatedTitle.includes("Lift Kits")) {
        descText = `Take your ${SEO_MODEL} to new heights with our selection of high-quality lift kits. These expertly designed kits provide the lift needed to conquer rugged terrain and add a unique off-road style to your vehicle. Explore our collection now to give your ${SEO_MODEL} the extra ground clearance it deserves, allowing you to explore new adventures and enjoy an elevated driving experience. Trust in our lift kits to enhance your ${SEO_MODEL}'s capabilities, both on and off the road.`;
    } else if (updatedTitle.includes("Shocks")) {
        descText = `Elevate Your ${SEO_MODEL}'s Driving Experience with Premium Shocks and Struts. Discover a smoother and more controlled ride with our high-quality shocks and struts designed to enhance your ${SEO_MODEL}'s comfort and handling. Explore our selection now and optimize your ${SEO_MODEL}'s suspension, ensuring a more enjoyable and responsive journey on the road. Shop top brands like Bilstein, Koni, Sachs, Vaico, and more!`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Springs`)) {
        descText = `By installing lowering springs on your ${SEO_MODEL}, you can enhance the appearance with a reduced fender gap, achieving a desirable stanced look. Additionally, lowering springs offer more than just aesthetics; they enhance the handling capabilities of your ${SEO_MODEL}. By lowering the center of gravity, body roll and front-end dive are reduced, resulting in improved stability and responsiveness. Shop our selection of lowering springs for your ${SEO_MODEL} now to improve handling and stance!`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Sway Bar`)) {
        descText = `Boost your ${SEO_MODEL}'s handling and cornering prowess with precision-engineered performance sway bars. These high-quality components are designed to reduce body roll, providing better control and stability during spirited drives. Shop our selection of sway bars and sway bar end links now to optimize your ${SEO_MODEL}'s performance, ensuring an exhilarating and confident driving experience.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Wheels`)) {
        descText = `Shop ${SEO_MODEL} aftermarket wheels at UroTuning. We sell aftermarket wheels, custom performance rims, and wheel accessories for your ${SEO_MODEL}. Shop upgraded wheels for your ${SEO_MODEL} build today! Not sure what you need? Contact one of our top-notch sales reps who can help you lock down the perfect set of wheels for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes(`${SEO_MODEL} Exhaust`) || updatedTitle.includes(`${SEO_MODEL} Engine Exhaust`)) {
        descText = `Unlock the full potential of your ${SEO_MODEL} and enhance your driving pleasure with the perfect exhaust system. At UroTuning, we offer an extensive range of high-quality ${SEO_MODEL} performance exhaust systems and parts, sourced from the most reputable brands in the industry. Our carefully curated selection ensures that you get the ultimate combination of power, style, and durability for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("Air Intake")) {
        descText = `Enhancing the performance of your ${SEO_MODEL} can be easily achieved by swapping out the factory air box with a high-quality aftermarket cold air intake. Explore our wide range of options from renowned brands to find the perfect air intake upgrade for your ${SEO_MODEL}.`;
    } else if (updatedTitle === `${SEO_MODEL} Engine Intake Parts`) {
        descText = `Ensure the optimal performance of your ${SEO_MODEL} with top-quality engine intake parts. Maintaining your vehicle with reliable engine intake components can help preserve its efficiency and functionality. Discover our comprehensive assortment of engine intake parts from trusted brands, tailored to keep your ${SEO_MODEL} running smoothly.`;
    } else if (updatedTitle.includes("Air Filter")) {
        descText = `Keep your ${SEO_MODEL} in top condition with our range of high-quality aftermarket air filters. Designed to protect your engine and enhance efficiency, UroTuning recommends changing your air filter every 20k miles to maintain optimal performance and fuel economy. Shop now for ${SEO_MODEL} air filters.`;
    } else if (updatedTitle.includes("Intake Manifold")) {
        descText = `Elevate your ${SEO_MODEL}'s engine performance with our specialized intake manifold parts. Our inventory includes essential components such as high-performance intake manifolds, gaskets, spacers, and more. Each part is designed to provide perfect fit and function for your ${SEO_MODEL}. Explore our selection of top-quality intake manifold parts from reputable brands to find the perfect upgrade for your ${SEO_MODEL}.`;
    } else if (updatedTitle.includes("Chargepipes") || updatedTitle.includes("Turbo Hoses")) {
        descText = `Upgrade your ${SEO_MODEL} with a high-quality chargepipe and inlet pipe to increase airflow and turbo efficiency. Choose from reinforced silicone, aluminum, or stainless steel options to boost your engine's power and response. Find the perfect chargepipe for your ${SEO_MODEL} from our selection of top-tier brands.`;
    } else if (updatedTitle === `${SEO_MODEL} Turbos`) {
        descText = `Maximize the power of your ${SEO_MODEL} with a top-of-the-line turbo kit. Upgrading to a larger turbo is a game-changer for a significant boost in horsepower! We also offer replacement OEM turbos to not only match but exceed the performance of your vehicle's factory turbocharger. Dive into our diverse range of turbo kits, tailored for your ${SEO_MODEL}, and experience the exhilarating surge of power that comes with a high-performance turbo upgrade.`;
    } else if (updatedTitle === `${SEO_MODEL} Turbo Parts`) {
        descText = `Upgrade your ${SEO_MODEL} with top-tier Turbo Parts. Our selection includes Blow Off and Diverter Valves, Turbo Pipes, Intercoolers, complete Turbos, and more. Shop our wide selection of Turbo parts to ensure your ${SEO_MODEL}'s Turbocharged Engine is boosting maximum power!`;
    } else if (updatedTitle === `${SEO_MODEL} Engine Tunes`) {
        descText = `One of the biggest performance gains and the most bang-for-your-buck mods you can do is a performance engine tune for your ${SEO_MODEL}. Get the most out of your ${SEO_MODEL} today with a tuning solution from some of the top performance engine tune brands available.`;
    } else if (updatedTitle.includes("Clutch")) {
        descText = `Explore our premium selection of clutch kits, perfectly tailored for your ${SEO_MODEL}. Enhance your driving experience with a high-performance or OEM replacement clutch kit. Shop now to find the ideal clutch solution for your ${SEO_MODEL}. Not sure what you need? Contact our experts to assist you in making the correct choice.`;
    } else {
        descText = "";
    }
  //console.log("++ desc returned: ", descText);
    return descText;
}

function setMetaTitle(seoData, updatedTitle){
  var titleNode = document.querySelector('title');
  var shopName = " – UroTuning"; 
  
  if(seoData){
    if(seoData.isSeoData != null){
      if(seoData.metaTitle != ''){
        titleNode.innerText = seoData.metaTitle
      } else {
        titleNode.innerText = updatedTitle + shopName;
      }
    } 
  } else {
    titleNode.innerText = updatedTitle + shopName;
  }
}

function setMetaDesc(seoData, descText){
  var metaDescNode = document.querySelector('meta[name="description"]');
  
  if(seoData){
    if(seoData.isSeoData != null){
      if(seoData.metaDesc != ''){
        metaDescNode.setAttribute("content", seoData.metaDesc);
      } else {
        if(descText != ''){
         metaDescNode.setAttribute("content", descText);
        }
      }
    } 
    } else {
      if(descText != ''){
       metaDescNode.setAttribute("content", descText);
      }
  }
}

function setCanonical(seoData){
  var canonicalNode = document.querySelector('link[rel="canonical"]');
  
  if(seoData){
    if(seoData.isSeoData != null){
      if(seoData.seoCanonical != ''){ 
            var clean_slug = cleanSlug(seoData.seoCanonical);
            canonicalNode.setAttribute("href", clean_slug);
            seoData.seoCanonical = '';
        } else {
            var this_slug = "https://www.urotuning.com" + window.location.pathname;
            this_slug = cleanSlug(this_slug);
            canonicalNode.setAttribute('href', this_slug);
        }
    } 
  } else {
      var this_slug = "https://www.urotuning.com" + window.location.pathname;
      this_slug = cleanSlug(this_slug);
      canonicalNode.setAttribute('href', this_slug);
  }
}

function setNoIndex(seoData){
  if(seoData){
    if(seoData.isSeoData != null){        
      if(seoData.NoIndex == "true"){
        var noIndexNode = document.querySelector('meta[name="robots"]');
        if(noIndexNode){
          noIndexNode.setAttribute('content', 'noindex');
        }else{
          metaNode = document.createElement('meta');
          metaNode.setAttribute('name', 'robots');
          metaNode.setAttribute('content', 'noindex');
          document.head.appendChild(metaNode);
        }
      } else {
        var noIndexNode = document.querySelector('meta[name="robots"]');
        if(noIndexNode){
          noIndexNode.remove();
        }
      }
    }
  } else{
    var noIndexNode = document.querySelector('meta[name="robots"]');
    if(noIndexNode){
      noIndexNode.remove();
    }
  }
}

function setH1(seoData, updatedTitle, descNode){
  if(seoData){
    if(seoData.isSeoData != null){
      if(seoData.seoH1 != ''){       
        var newh1 = document.createElement('h1');
        newh1.innerHTML = seoData.seoH1;
        descNode.appendChild(newh1);

        document.querySelectorAll("h1").forEach(h1 => {
          h1.innerHTML = seoData.seoH1;
        });
      } else {        
        var newh1 = document.createElement('h1');
        newh1.innerHTML = updatedTitle;
        descNode.appendChild(newh1);

        document.querySelectorAll("h1").forEach(h1 => {
          h1.innerHTML = updatedTitle;
        });
      }
    } 
  } else {
    document.querySelectorAll("h1").forEach(h1 => {
      h1.innerHTML = updatedTitle;
    });
  
    var newh1 = document.createElement('h1');
    newh1.innerHTML = updatedTitle;      
    descNode.appendChild(newh1);
  }
}



function setContentTop(seoData, descText, descNode){ 
  const hideH1styles = document.createElement('style');
  hideH1styles.textContent = `.findify-container .findify-collection-header-wrapper { display: none !important; }`;
  const currentPath = window.location.pathname;
  
  if(seoData){
    if(seoData.isSeoData != null){
      if(seoData.seoPageTop != ''){
        var temp = document.createElement('div');
        temp.innerHTML = seoData.seoPageTop;
        descNode.appendChild(temp);

        document.querySelectorAll("#top-cat").forEach(x => {
          //console.log("TOPC UPDATED!");
          x.innerHTML = '';
          x.innerHTML = seoData.seoPageTop;
        });
        
        if (currentPath != '/collections/all/') {
          descNode.appendChild(hideH1styles);
        } 
      } else {
        var temp = document.createElement('p');
        temp.innerHTML = descText;
        descNode.appendChild(temp);
        
        document.querySelectorAll("#top-cat").forEach(x => {
          //console.log("TOPC UPDATED!");
          x.innerHTML = '';
          x.innerHTML = descText;
        });
        
        if (currentPath != '/collections/all/') {
          descNode.appendChild(hideH1styles);
        } 
      }
    } 
  } else {
      var temp = document.createElement('p');
      temp.innerHTML = descText
      descNode.appendChild(temp); 
      if (currentPath != '/collections/all/') {
        descNode.appendChild(hideH1styles);
      } 
  }
}

function setContentBottom(seoData){
  var bottomDescNode = document.getElementById('category__bottom_desc');
  if (!bottomDescNode) return;

  // Only overwrite when we have a real match and real content
  if (seoData && seoData.isSeoData != null && seoData.seoPageBottom && seoData.seoPageBottom !== '') {
    bottomDescNode.innerHTML = seoData.seoPageBottom;
  }

  // If no seoData match, leave whatever Liquid already rendered
}



(function () {
  function getDynamicCategoryFromUrl() {
    // Example expected patterns:
    // /collections/audi-a3-8y-sedan-2-0t-fwd__drivetrain
    // or /collections/handle__drivetrain__clutch etc
    var path = window.location.pathname || "";
    if (!path.startsWith("/collections/")) return null;

    // strip leading /collections/
    var parts = path.split("/").filter(Boolean);
    if (parts.length < 2) return null;

    var handlePart = parts[1]; // could include "__"
    if (handlePart.indexOf("__") === -1) return null;

    var parsed = parseCollectionPath(["collections", handlePart].join("/"));
    if (!parsed || !parsed.categories || !parsed.categories.length) return null;

    // last category segment is what you want as final crumb
    return parsed.categories[parsed.categories.length - 1];
  }

  function updateBread(categoryLabel) {
    var bread = document.querySelector("#bread");
    if (!bread) return;

    // Remove previous injected crumb if present
    var existing = bread.querySelector('[data-findify-dynamic-crumb="true"]');
    if (existing) {
      // also remove the separator immediately before it if we inserted one
      var prev = existing.previousSibling;
      // remove possible whitespace nodes then arrow span
      while (prev && prev.nodeType === 3 && !prev.textContent.trim()) prev = prev.previousSibling;
      if (prev && prev.nodeType === 1 && prev.classList.contains("arrow")) prev.remove();
      existing.remove();
    }

    if (!categoryLabel) return;

    // Do not duplicate if it is already in the breadcrumb
    var names = [].slice.call(bread.querySelectorAll('span[itemprop="itemListElement"] span[itemprop="name"]'))
      .map(function (x) { return (x.textContent || "").trim().toLowerCase(); });

    if (names.indexOf(categoryLabel.trim().toLowerCase()) !== -1) return;

    // Add separator
    var sep = document.createElement("span");
    sep.className = "arrow";
    sep.textContent = "/";

    // Add crumb (as a link if you want later)
    var wrap = document.createElement("span");
    wrap.setAttribute("data-findify-dynamic-crumb", "true");
    wrap.setAttribute("itemprop", "itemListElement");
    wrap.setAttribute("itemscope", "");
    wrap.setAttribute("itemtype", "https://schema.org/ListItem");

    var name = document.createElement("span");
    name.setAttribute("itemprop", "name");
    name.textContent = categoryLabel;

    wrap.appendChild(name);

    bread.appendChild(document.createTextNode(" "));
    bread.appendChild(sep);
    bread.appendChild(document.createTextNode(" "));
    bread.appendChild(wrap);
  }

  function sync() {
    var cat = getDynamicCategoryFromUrl();
    updateBread(cat);
  }

  // Run once on load
  sync();

  // Listen for SPA URL changes
  var _pushState = history.pushState;
  var _replaceState = history.replaceState;

  function onUrlChange() {
    setTimeout(sync, 50);
    setTimeout(sync, 250);
  }

  history.pushState = function () {
    _pushState.apply(this, arguments);
    onUrlChange();
  };

  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    onUrlChange();
  };

  window.addEventListener("popstate", onUrlChange);
})();
